import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ResortInner from '../Components/Resort/ResortInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function Resort() {
    const { title, bgImage } = usePageBanner({
        pageSlug: 'resorts',
        fallbackTitle: 'Resort',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ResortInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Resort
